import { useEffect, useRef } from "react";

const useAsyncEffect = (effect, deps = []) => {
    const effectRef = useRef(effect);
    effectRef.current = effect;

    useEffect(() => {
        let mounted = true;
        let cleanup;

        (async () => {
            const maybeCleanup = await effectRef.current();
            if (!mounted) return;
            cleanup = maybeCleanup;
        })();

        return () => {
            mounted = false;
            if (typeof cleanup === "function") {
                cleanup();
            }
        };
    }, deps);
};

export default useAsyncEffect;
